import { render, staticRenderFns } from "./premesisEquipment.vue?vue&type=template&id=3c517619&"
import script from "./premesisEquipment.vue?vue&type=script&lang=js&"
export * from "./premesisEquipment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c517619')) {
      api.createRecord('3c517619', component.options)
    } else {
      api.reload('3c517619', component.options)
    }
    module.hot.accept("./premesisEquipment.vue?vue&type=template&id=3c517619&", function () {
      api.rerender('3c517619', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Premises/premesisEquipment.vue"
export default component.exports